import { Link, useParams } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryTabs() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
          !slug
            ? "bg-primary-500 text-background-50"
            : "bg-background-100 text-foreground-600 hover:bg-background-200"
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-1.5 ${
            slug === cat.slug
              ? `bg-${cat.color}-500 text-background-50`
              : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}
          style={
            slug === cat.slug
              ? cat.color === "accent"
                ? { backgroundColor: "oklch(var(--accent-500))", color: "oklch(var(--background-50))" }
                : cat.color === "secondary"
                  ? { backgroundColor: "oklch(var(--secondary-500))", color: "oklch(var(--background-50))" }
                  : { backgroundColor: "oklch(var(--primary-500))", color: "oklch(var(--background-50))" }
              : {}
          }
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}